import React from 'react';
import Article from './Article';
import Graf from './Graf';

export default function ReturnsAndRefunds() {
  return (
    <Article
      title="Returns & Refunds"
      anchorTagText="support@saucey.com"
      asideTitle="contact"
    >
      <Graf>
        Returns and replacements are not accepted once the order has been
        received by a verified customer/recipient. If the incorrect item is
        delivered or the item is spoiled, contaminated or otherwise not
        consumable, please reach out to us at support@saucey.com.
      </Graf>
    </Article>
  );
}
